<div [formGroup]="contactForm">
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="First name" formControlName="firstName"
             [errorStateMatcher]="errorMatcher"/>
      <mat-error>First name is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="Last name" formControlName="lastName"
             [errorStateMatcher]="errorMatcher"/>
      <mat-error>Last name is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="Email" formControlName="email"
             [errorStateMatcher]="errorMatcher"/>
      <mat-error>Valid email is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="Telephone" formControlName="phone" />
      <mat-error>Phone number is required</mat-error>
    </mat-form-field>
    <mat-form-field class="mat-field-width">
      <input matInput placeholder="Contact business name" formControlName="company" />
      <mat-error>Company name is required</mat-error>
    </mat-form-field>
  </div>
  